import PropTypes from "prop-types";
import React from "react";
import GoogleMapReact from "google-map-react";

// const AnyReactComponent = ({ text }) => <div>{text}</div>;

const createMapOptions = () => ({
  panControl: false,
  mapTypeControl: false,
  scrollwheel: false,
  stylers: [
    { saturation: -100 },
    { gamma: 0.8 },
    { lightness: 4 },
    { visibility: "on" },
  ],
});

const Map = ({ props }) => (
  <div css={{ height: "100%", width: "100%" }}>
    <GoogleMapReact
      options={createMapOptions}
      bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAPS_KEY as string }}
      // language='de'
      defaultCenter={props.center}
      defaultZoom={props.zoom}
    >
      {/* <AnyReactComponent
				css={{width: '100%', height: '100%'}}
				lat={props.center.lat}
				lng={props.center.lng}
			/> */}
    </GoogleMapReact>
  </div>
);

export default Map;
